/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';
import { useState } from 'react';

import { useField } from 'formik';

import DataList from '~/components/DataList';
import InputSearch from '~/components/Formik/InputSearch';
import Modal from '~/components/Modal';

import { Container } from '../DataListInput/styles';

export interface SelectListValue {
  id: string;
  label: string;
  value: string;
}

interface SelectListInputProps {
  pathToList: string;
  pathToLoading: string;
  pathToTotal: string;
  pathToData: string;
  fieldId: string;
  fieldName: string;
  fieldLabel: string;
  isDisabled?: boolean;
  idValue: string;
  labelValue: string;
  value: string;
  isMulti?: boolean;
  solicitationData?: {
    id: string | undefined;
    strictChildren?: boolean;
  };
  onChange?: (values?: SelectListValue[]) => void;
  onLoad: (search: string, page: number, limit: number) => void;
}

function SelectListInput({
  pathToList,
  pathToLoading,
  pathToTotal,
  pathToData,
  fieldId,
  fieldName,
  fieldLabel,
  isDisabled,
  isMulti,
  idValue,
  labelValue,
  value,
  onLoad,
  onChange,
  solicitationData,
}: SelectListInputProps) {
  const [selectListModal, setSelectListModal] = useState<boolean>(false);

  const [field, meta, helpers] = useField<SelectListValue[] | undefined>(
    fieldName,
  );
  const { value: selectListValue } = field;
  const { error, initialValue } = meta;
  const { setValue: setSelectListValue } = helpers;

  useEffect(() => {
    if (solicitationData?.strictChildren) {
      setSelectListValue(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solicitationData?.id]);

  useEffect(() => {
    setSelectListValue(initialValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  return (
    <Container>
      <InputSearch<SelectListValue>
        key={fieldId}
        name={fieldName}
        label={fieldLabel}
        value={selectListValue}
        onUpdateValues={(newValues) => {
          setSelectListValue(newValues);
          if (onChange) onChange(newValues);
        }}
        disabled={isDisabled}
        onClickSearch={() => setSelectListModal(true)}
        error={error}
      />
      {selectListModal && (
        <Modal
          title={fieldLabel}
          open={selectListModal}
          modalState={(opened) => setSelectListModal(opened)}
        >
          <DataList<SelectListValue>
            isMulti={isMulti}
            values={selectListValue ?? null}
            callback={(values) => {
              setSelectListValue(values);
              if (onChange) onChange(values);
              setSelectListModal(false);
            }}
            onLoad={(_, search, page, limit) => onLoad(search, page, limit)}
            pathToList={pathToList}
            pathToLoading={pathToLoading}
            pathToTotal={pathToTotal}
            pathToData={pathToData}
            mapProps={{
              id: `${idValue}`,
              label: `${labelValue}`,
              value: `${value}`,
            }}
          />
        </Modal>
      )}
    </Container>
  );
}

export default SelectListInput;
